import styled, { keyframes } from 'styled-components'

const horizontalFloat = keyframes`
	0% {
		margin-left: 0;
		transform: rotate(10deg);
	}
	50% {
		transform: rotate(0deg);
	}
	100% {
		margin-left: 275px;
	}
`

const horizontalFloatMobile = keyframes`
	0% {
		margin-left: 0;
		transform: rotate(10deg);
	}
	50% {
		transform: rotate(0deg);
	}
	100% {
		margin-left: 190px;
	}
`

export const Container = styled.div`
	width: 300px;
	height: 193px;
	position: relative;
	-ms-perspective: 800px;
	perspective: 800px;
	border-radius: 4px;
	animation: ${horizontalFloat} 10000ms linear alternate infinite;
	
	@media(max-width: 1024px) {
		animation: ${horizontalFloatMobile} 10000ms linear alternate infinite;
	}

	.card {
		position: absolute;
		transform-style: preserve-3d;
		transition: transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
		border-radius: 6px;
		box-shadow: 0 6px 16px rgba(0,0,0,0.15);
		cursor: pointer;

		div {
			position: absolute;
			width: 100%;
			height: 100%;
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			border-radius: 6px;
			background: #fff;
			display: -ms-flexbox;
			display: box;
			display: flex;
			-o-box-pack: center;
			justify-content: center;
			-o-box-align: center;
			align-items: center;
			background-repeat: no-repeat;
			background-size: 100%;

			&.front {
				background-image: url(${props => props.frontImage});
			}

			&.back {
				transform: rotateY(180deg);
				background-image: url(${props => props.backImage});
			}
		}

		&.flipped {
			transform: rotateY(180deg);
		}
	}
`
